module.exports = __webpack_public_path__ + "static/media/Play.a034ff45.png";